import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';

function GreeceMap() {

    const center = [39.0742, 21.8243];
    const zoom = 7;

    
    
        const airports = [
            { name: 'Διεθνής Αερολιμένας Αθηνών «Ελευθέριος Βενιζέλος', location: [37.9364, 23.9445] },
            { name: 'Διεθνής Αερολιμένας Θεσσαλονίκης «Μακεδονία»', location: [40.5199, 22.9707] },
            { name: "Κρατικός Αερολιμένας Καρπάθου", location: [35.4214, 27.1467] },
            { name: 'Κρατικός Αερολιμένας Αλεξανδρούπολης «Δημόκριτος»', location: [40.8559, 25.9565] },
            { name: 'Κρατικός Αερολιμένας Κέρκυρας «Ι. Καποδίστριας»', location: [39.6061, 19.9147] },
            { name: 'Διεθνής Αερολιμένας Χανίων «Ιωάννης Δασκαλογιάννης»', location: [35.5409, 24.1404] },
            { name: 'Κρατικός Αερολιμένας Κεφαλληνίας', location: [38.1197, 20.5009] },
            { name: 'Κρατικός Αερολιμένας Αράξου', location: [38.1511, 21.4256] },
            { name: 'Κρατικός Αερολιμένας Ηρακλείου «Νίκος Καζαντζάκης»', location: [35.3367, 25.1748] },
            { name: 'Κρατικός Αερολιμένας Ιωαννίνων «Βασιλεύς Πύρρος»', location: [39.6983, 20.8225] },
            { name: 'Κρατικός Αερολιμένας Ικαρίας «Ίκαρος»', location: [37.6833, 26.35] },
            { name: 'Κρατικός Αερολιμένας Χίου «Όμηρος»', location: [38.3431, 26.1416] },
            { name: 'Κρατικός Αερολιμένας Καλύμνου', location: [36.9631, 26.9403] },
            { name: 'Κρατικός Αερολιμένας Μυκόνου', location: [37.435, 25.3481] },
            { name: 'Κρατικός Αερολιμένας Νάξου «Απόλλων»', location: [37.0808, 25.3681] },
            { name: 'Δημοτικός Αερολιμένας Σητείας «Βιτσέντζος Κορνάρος»', location: [35.2161, 26.1014] },
            { name: 'Κρατικός Αερολιμένας Σκιάθου «Αλέξανδρος Παπαδιαμάντης»', location: [39.1772, 23.5036] },
            { name: 'Κρατικός Αερολιμένας Σύρου «Δημήτριος Βικέλας»', location: [37.4228, 24.9508] },
            { name: 'Κρατικός Αερολιμένας Σαντορίνης', location: [36.3992, 25.4793] },
            { name: 'Κρατικός Αερολιμένας Αστυπάλαιας', location: [36.5794, 26.375] },
            { name: 'Κρατικός Αερολιμένας Καστοριάς «Αριστοτέλης»', location: [40.4469, 21.2822] },
            { name: 'Κρατικός Αερολιμένας Καβάλας «Μέγας Αλέξανδρος»', location: [40.9133, 24.6197] },
            { name: 'Κρατικός Αερολιμένας Κοζάνης «Φίλιππος»', location: [40.2861, 21.8406] },
            { name: 'Δημοτικός Αερολιμένας Καστελόριζου', location: [36.1278, 29.5664] },
            { name: 'Κρατικός Αερολιμένας Κυθήρων «Αλέξανδρος Αριστοτέλους Ωνάσης»', location: [36.2742, 23.0167] },
            { name: 'Κρατικός Αερολιμένας Καλαμάτας «Καπετάν Βασ. Κωνσταντακόπουλος»', location: [37.0683, 22.0256] },
            { name: 'Δημοτικός Αερολιμένας Κάσου', location: [35.4217, 26.9097] },
            { name: 'Κρατικός Αερολιμένας Λήμνου «Ήφαιστος»', location: [39.9164, 25.2389] },
            { name: 'Κρατικός Αερολιμένας Μυτιλήνης «Οδυσσέας Ελύτης»', location: [39.0567, 26.5983] },
            { name: 'Δημοτικός Αερολιμένας Λέρου', location: [37.1847, 26.8009] },
            { name: 'Κρατικός Αερολιμένας Μήλου', location: [36.6969, 24.4775] },
            { name: 'Κρατικός Αερολιμένας Πάρου', location: [37.0103, 25.1272] },
            { name: 'Κρατικός Αερολιμένας Ακτίου', location: [38.9256, 20.7653] },
            { name: 'Κρατικός Αερολιμένας Ρόδου «Διαγόρας»', location: [36.4053, 28.0861] },
            { name: 'Κρατικός Αερολιμένας Σκύρου', location: [38.9675, 24.4872] },
            { name: 'Κρατικός Αερολιμένας Σάμου «Αρίσταρχος ο Σάμιος»', location: [37.6892, 26.9117] },
            { name: 'Κρατικός Αερολιμένας Νέας Αγχιάλου', location: [39.2192, 22.7944] },
            { name: 'Κρατικός Αερολιμένας Κω «Ιπποκράτης»', location: [36.7951, 27.0917] },
            { name: 'Κρατικός Αερολιμένας Ζακύνθου «Διονύσιος Σολωμός»', location: [37.7508, 20.8847] }
          ];

    return (
        <div className = "container" style = {{marginBottom: "10%"}}>
                <MapContainer
                center={center}
                zoom={zoom}
                //SOS It MUST HAVE STATIC HEIGHT IN ORDER TO SHOW
                style={{ height: "500px", width: "100%" }}
                >
                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                />


                {airports.map((airport, index) => (
                    <Marker key={index} position={airport.location}>
                    <Popup>{airport.name}</Popup>
                    </Marker>
                ))}
                
            </MapContainer>
        </div>
    );
};

export default GreeceMap;
